const initialState = () => ({
  currentCorporation: {},
  partnerSettings: {},
  puTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  psmList: [],
  tuTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  platformSmacUsers: [],
  showActiveUsers: true,
  activeTab: 'general',
  platformUsers: [],
  technicianUsers: [],
  loadingPlatformUsers: true,
  loadingTechnicians: true,
  puTableSearch: '',
  tuTableSearch: '',
  actionModalView: '',
  showActionModal: false,
  actionIntModalView: '',
  showIntActionModal: false,
  parsingTechnician: false,
  currentUser: {
    superAdmin: false,
    corporationId: 0,
  },
  currentTechnician: {
    corporationId: 0,
  },
  editing: false,
  loadingCurrentCorporation: true,
  loadingCurrentUser: false,
  taxExemptCategory: [],
  errorObj: {},
  userType: '',
  selectedCorp: 0,
  warningDetailTab: '',
  cardToken: '',
  source: '',
  paymentMethodId: '',
  paymentMethod: '',
  selectedPaymentMethod: [],
  setupIntent: {},
  loadingPaymentMethod: false,
  processingDirectDebit: false,
  recentInvoices: [],
  subscriptions: [],
  chargebeeCustomer: {},
  chargebeeContactId: '',
  agreementBilling: {},
  alertTypes: [],
  agreements: [],
  serviceCategoryList: [],

  loadingInvoices: true,
  loadingSubscriptions: true,
  loadingSettings: false,
});

export default initialState;
